export default __webpack_public_path__ + "static/media/terraform-icon.a2330b8d.svg";